<template>
  <div class="cesium-container" :class="{ 'data-ui': isDataUi, 'filght-sumulation': FlightSimulationFlag }">
    <MediaView @close="closeCurrentMedia" :currentIndex="currentIndex" :mediaList="currentMediaList"
      @toggle-map="setCurrent" @prev="setCurrent" @next="setCurrent" @switch="mediaSwitch" />
    <div class="notie-list" v-show="!isDataUi && !FlightSimulationFlag" v-if="notieList.length > 0"
      :class="{ active: getActive, 'is-waline-edit': isWaylineEdit, 'is-device': is_waylineDevice, 'is-template': is_waylineTemplate }">
      <div class="notie-title-type">{{ notieList[0].categoryName }}</div>
      <div class="notie-title-value">
        {{notieList.map(dict => dict.title).join()}}
      </div>
      <router-link :to="{ path: 'notie-detail' }" target="_blank" class="detail-btn">
        <div>详情</div>
        <div class="arrow-right" />
      </router-link>
    </div>
    <!-- 建筑模型控制面板 -->
    <div v-if="showBuildingControls" class="building-control-panel">
      <div class="panel-header">
        <h4>3D建筑模型</h4>
        <CloseOutlined @click="showBuildingControls = false" />
      </div>

      <div class="panel-content">
        <!-- 错误提示 -->
        <div v-if="buildingError" class="error-message">
          <a-alert :message="buildingError" type="error" show-icon />
        </div>
        <a-select v-model:value="selectedBuildingLayer" placeholder="选择建筑数据源" style="width: 100%; margin-bottom: 10px;"
          @change="handleBuildingLayerChange">
          <a-select-option value="osm">OSM建筑数据（免费）</a-select-option>
          <a-select-option value="test">测试建筑模型</a-select-option>
          <a-select-option value="custom">自定义3D Tiles</a-select-option>
          <!-- 可以添加更多选项 -->
        </a-select>

        <div v-if="selectedBuildingLayer === 'custom'" class="custom-input">
          <a-alert message="请输入有效的3D Tiles URL" type="info" show-icon style="margin-bottom: 10px;" />
          <a-input v-model:value="customTilesetUrl" placeholder="例如: https://example.com/tileset.json"
            style="margin-bottom: 10px;" />
          <a-button type="primary" @click="loadCustomBuildings" block>加载</a-button>
        </div>

        <div v-if="selectedBuildingLayer === 'osm'" class="data-source-info">
          <a-alert message="使用ArcGIS免费3D建筑数据，加载可能需要一些时间" type="warning" show-icon style="margin-bottom: 10px;" />
        </div>

        <div class="building-controls">
          <a-button type="primary" :disabled="!currentBuildingTileset" @click="toggleBuildings">
            {{ buildingsVisible ? '隐藏' : '显示' }}建筑
          </a-button>

          <a-button :disabled="!currentBuildingTileset" @click="removeBuildings" style="margin-left: 10px;">
            移除
          </a-button>
        </div>

        <!-- 性能统计 -->
        <div v-if="currentBuildingTileset" class="performance-stats">
          <div class="stat-item">
            <span>加载级别:</span>
            <a-progress :percent="loadProgress" size="small" style="width: 60px; margin-left: 10px;" />
          </div>
          <div v-if="memoryUsage > 0" class="stat-item">
            <span>内存使用:</span>
            <span>{{ memoryUsage }} MB</span>
          </div>
        </div>

        <!-- 使用说明 -->
        <div class="usage-tips">
          <a-alert message="使用提示" description="1. 免费数据源可能较慢 2. 大型模型需要良好网络 3. 建议先加载测试模型" type="info" show-icon />
        </div>

      </div>
    </div>
    <div class="map-sidebar-com">
      <FlySetting />
      <MarkInfo />
      <div class="route-core-info" :class="{ 'is-template': is_waylineTemplate, 'is-device': is_waylineDevice }"
        style="" v-if="waylineInfo && Object.keys(waylineInfo).length > 0">
        <div class="top">
          <div class="route-name">{{ waylineInfo.name }}</div>
          <div class="create-info">
            <user-outlined />
            <div class="creator">{{ waylineInfo.user_name }}</div>
            <div class="phone"></div>
            <clock-circle-outlined />
            <div class="create-time">{{ dayjs(waylineInfo.create_time).format('YYYY-MM-DD') }}</div>
          </div>
        </div>
        <div class="bottom">
          <div class="wayline-info-item">
            <div class="title"> 航线长度 </div>
            <div class="text">{{ waylineInfo.wayline_length }} 米 </div>
          </div>
          <div class="wayline-info-item" style="">
            <div class="title"> 航点数量 </div>
            <div class="text">{{ waylineInfo.wayline_count }} 个 </div>
          </div>
          <div class="wayline-info-item">
            <div class="title"> 关联机场 </div>
            <div class="text">--</div>
          </div>
          <div class="wayline-info-item">
            <div class="title"> 航线属性 </div>
            <span class="text">通用航线</span>
          </div>
          <div class="wayline-info-item end-update-time">
            <div class="title"> 最后修改时间 </div>
            <span class="update-time">{{ dayjs(waylineInfo.update_time).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </div>
        </div>
      </div>
      <!-- 操作按钮面板 -->
      <div class="cesium-action-pane" :class="{ edit: showEditRouter }"
        v-show="!isSettingPlanar && !isDataUi && !FlightSimulationFlag">
        <!-- 绘制模式 -->
        <g-action-type class="g-action-item mt10" :class="{ 'selection': states.isDraw }"
        @select-action="drawCesium" @click="drawCesium"></g-action-type>
         <div v-if="states.isDraw" class="g-action-item" @click="drawCesium(states.currentType)">
          <a style="color: red;">
            <CloseOutlined />
          </a>
        </div>
        <div class="g-action-item model-list-btn" @mouseenter="showModelChange" @mouseleave="handleMouseLeave"
        v-if="modelTreeData.length > 0">
        <unordered-list-outlined />
        <!-- 树形结构模型列表悬停面板 -->
        <div v-if="showModelList && modelTreeData.length > 0" class="tree-model-list-popover"
          @mouseenter="keepModelList = true" @mouseleave="hideModelList">
          <div class="tree-list-header">
            <span class="tree-list-title">模型树列表</span>
            <span class="model-count">{{ getTotalModelCount() }}个模型</span>
          </div>

          <div class="tree-list-content">
            <!-- 树形结构展示 -->
            <div v-for="workspace in modelTreeData" :key="workspace.key" class="tree-workspace">
              <!-- 工作空间节点 -->
              <div class="tree-workspace-header" @click="toggleTreeNode(workspace.key)">
                <div class="tree-node-title">
                  <caret-right-outlined v-if="!expandedTreeNodes[workspace.key]" class="tree-caret-icon" />
                  <caret-down-outlined v-else class="tree-caret-icon" />
                  <span class="tree-node-name">{{ workspace.title }}</span>
                  <span class="tree-node-count">{{ countWorkspaceModels(workspace) }}</span>
                </div>
              </div>

              <!-- 工作空间子节点 -->
              <div v-if="expandedTreeNodes[workspace.key]" class="tree-children">
                <!-- 一级文件夹 -->
                <div v-for="folder in workspace.children" :key="folder.key" class="tree-folder">
                  <div class="tree-folder-header" @click="toggleTreeNode(folder.key)">
                    <div class="tree-node-title">
                      <caret-right-outlined v-if="!expandedTreeNodes[folder.key]" class="tree-caret-icon" />
                      <caret-down-outlined v-else class="tree-caret-icon" />
                      <span class="tree-node-name">{{ folder.title }}</span>
                      <span class="tree-node-count">{{ countFolderModels(folder) }}</span>
                    </div>
                  </div>

                  <!-- 二级文件夹 -->
                  <div v-if="expandedTreeNodes[folder.key] && folder.children && folder.children.length > 0"
                    class="tree-subfolders">
                    <div v-for="subFolder in folder.children" :key="subFolder.key" class="tree-subfolder">
                      <div class="tree-subfolder-header" @click="toggleTreeNode(subFolder.key)">
                        <div class="tree-node-title">
                          <caret-right-outlined v-if="!expandedTreeNodes[subFolder.key]" class="tree-caret-icon" />
                          <caret-down-outlined v-else class="tree-caret-icon" />
                          <span class="tree-node-name">{{ subFolder.title }}</span>
                          <span class="tree-node-count">{{ countSubFolderModels(subFolder) }}</span>
                        </div>
                      </div>

                      <!-- 模型节点 -->
                      <div
                        v-if="expandedTreeNodes[subFolder.key] && subFolder.children && subFolder.children.length > 0"
                        class="tree-models">
                        <div v-for="model in subFolder.children" :key="model.key" class="tree-model">
                          <div class="tree-model-header" @click="toggleTreeNode(model.key)">
                            <div class="tree-node-title">
                              <caret-right-outlined v-if="!expandedTreeNodes[model.key]" class="tree-caret-icon" />
                              <caret-down-outlined v-else class="tree-caret-icon" />
                              <span class="tree-node-name">{{ model.title }}</span>
                              <span class="tree-node-count">{{ countModelTypes(model) }}</span>
                            </div>
                          </div>

                          <!-- 模型类型节点 -->
                          <div v-if="expandedTreeNodes[model.key] && model.children && model.children.length > 0"
                            class="tree-model-types">
                            <div v-for="modelType in model.children" :key="modelType.key" class="tree-model-type"
                              :class="{ 'active': isModelTypeActive(modelType.key) }"
                              @click="selectModelType(modelType)">
                              <div class="model-type-content">
                                <div class="model-type-icon">
                                  <file-text-outlined v-if="modelType.dataRef.type === 'model'" />
                                  <file-outlined v-else />
                                </div>
                                <div class="model-type-info">
                                  <span class="model-type-name">{{ modelType.title }}</span>
                                  <span class="model-type-desc">{{ getModelTypeDesc(modelType.dataRef.type) }}</span>
                                </div>
                                <check-outlined v-if="isModelTypeActive(modelType.key)" class="model-type-check" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <!-- <div class="g-action-item" @click="showBuildingControls = !showBuildingControls">
          <HomeFilled />
        </div> -->
        <div v-if="showEditRouter" class="g-action-item" :class="{ selection: states.currentType === 'PointLine' }"
          @click="drawCesium('PointLine')">
          <a>
            <ForkOutlined />
          </a>
        </div>
        <FlightAreaActionIcon v-if="isFlightAreaRouter" class="g-action-item mt10" :class="{ 'selection': mouseMode && isFlightArea }"
          @select-action="selectFlightAreaAction" @click="selectFlightAreaAction" />
        <div v-if="mouseMode" class="g-action-item" @click="draw('off', false)">
          <a style="color: red;">
            <CloseOutlined />
          </a>
        </div>
      </div>
      <flyContrainer v-if="FlightSimulationFlag"></flyContrainer>
      <!-- 飞行区绘制弹层 -->
      <FlightAreaDrawModal v-model="showDrawModal" :area-data="currentAreaData" @confirm="handleAreaConfirm"
        @cancel="handleAreaCancel" />
      <AirportModal />
      <div class="share-point-panel" v-if="sharePane.show">
        <div class="share-btn">扫码分享</div>
        <div class="share-image-box">
        <qrcode-vue :value="sharePane.img" :size="104" level="H" />
        </div>
      </div>
      <div class="m-s-right-btn" :class="{ 'data-ui': isDataUi }">

        <a-popover overlayClassName="css-vslrb1" placement="left" trigger="hover">
          <template #title>{{ '' }}</template>
          <template #content>
            <a-switch v-model:checked="showPointCloud" checked-children="点云-开启" un-checked-children="点云-关闭"></a-switch>
            <br />
            <a-switch v-model:checked="showModelTileset" checked-children="模型-开启"
              un-checked-children="模型-关闭"></a-switch>
          </template>
          <div class="m-s-icon td">
            <radar-chart-outlined />
          </div>
        </a-popover>
        <div class="m-s-icon td" @click="handleChangeModel">{{ MapTypeName[states.mapType] }}</div>

        <a-popover overlayClassName="css-vslrb1" placement="left" trigger="hover">
          <template #title>{{ '' }}</template>
          <template #content>
            <div class="flight-area">
              <div class="f-a-switch">
                <a-switch class="css-vslrb1" v-model:checked="isFlyArea" @change="handleSwitchChange"></a-switch>
                <div class="txt"> 显示自定义飞行区 </div>
              </div>
              <a-divider class="css-vslrb1" style="margin: 8px 0px;" />
              <div class="f-a-txt">
                <div class="round color1"></div>
                <div class="txt"> 自定义限飞区 </div>
              </div>
              <div class="f-a-txt">
                <div class="round color2"></div>
                <div class="txt"> 自定义作业区 </div>
              </div>
              <div class="f-a-switch">
                <a-switch class="css-vslrb1" v-model:checked="isCustumFlyArea"
                  @change="handleSwitchCustumChange"></a-switch>
                <div class="txt"> 显示限飞区 </div>
              </div>
              <a-divider class="css-vslrb1" style="margin: 8px 0px;" />
              <div class="f-a-check">
                <a-checkbox v-model:checked="isCustumFlyArea" @change="handleSwitchCustumChange(!isCustumFlyArea)">
                  <div class="check-content">
                    <div class="round color3"></div>
                    <div class="check-txt"> 禁飞区 </div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox v-model:checked="isCustumFlyArea" @change="handleSwitchCustumChange(!isCustumFlyArea)">
                  <div class="check-content">
                    <div class="round color4"></div>
                    <div class="check-txt"> 限高区 </div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox v-model:checked="isCustumFlyArea" @change="handleSwitchCustumChange(!isCustumFlyArea)">
                  <div class="check-content">
                    <div class="round color5"></div>
                    <div class="check-txt"> 授权区 </div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox v-model:checked="isCustumFlyArea" @change="handleSwitchCustumChange(!isCustumFlyArea)">
                  <div class="check-content">
                    <div class="round color6"></div>
                    <div class="check-txt"> 警示区 </div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox v-model:checked="isCustumFlyArea" @change="handleSwitchCustumChange(!isCustumFlyArea)">
                  <div class="check-content">
                    <div class="round color7"></div>
                    <div class="check-txt"> 加强警示区 </div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox v-model:checked="isCustumFlyArea" @change="handleSwitchCustumChange(!isCustumFlyArea)">
                  <div class="check-content">
                    <div class="round color8"></div>
                    <div class="check-txt"> 法规限制区 </div>
                  </div>
                </a-checkbox>
              </div>
              <div class="f-a-check">
                <a-checkbox v-model:checked="isCustumFlyArea" @change="handleSwitchCustumChange(!isCustumFlyArea)">
                  <div class="check-content">
                    <div class="round color9"></div>
                    <div class="check-txt"> 轻型无人机适飞区 </div>
                  </div>
                </a-checkbox>
              </div>
              <a-divider class="css-vslrb1" style="margin: 8px 0px;" />
              <div class="f-a-tips"> 查看临时限飞区 </div>
            </div>
          </template>
          <div class="m-s-icon td">
            <info-circle-outlined />
          </div>
        </a-popover>

        <a-popover overlayClassName="css-vslrb1" placement="left" trigger="hover">
          <template #title>{{ '' }}</template>
          <template #content>
            <div class="uva-level">
              <div class="v-l-tip">
                <div class="tip-txt"> 载人飞机碰撞风险 </div>
                <div class="tip-txt">
                  <i class="iconfont icon-shezhi" @click="handleShowFlySetting"></i>
                </div>
              </div>
              <div class="v-l-check">
                <a-checkbox v-model:checked="flyErrorStatus"
                  @change="handleChangeCheckChange('flyErrorStatus', !flyErrorStatus)">
                  <div class="check-content">
                    <svg-icon name="fly" :size="18" color="#dc4446" className="color-error"></svg-icon>
                    <div class="check-txt"> 高风险 </div>
                  </div>
                </a-checkbox>
              </div>
              <div class="v-l-check">
                <a-checkbox v-model:checked="flyWarningStatus"
                  @change="handleChangeCheckChange('flyWarningStatus', !flyWarningStatus)">
                  <div class="check-content">
                    <svg-icon name="fly" :size="18" color="#d89614" className="color-warning"></svg-icon>
                    <div class="check-txt"> 中风险 </div>
                  </div>
                </a-checkbox>
              </div>
              <div class="v-l-check">
                <a-checkbox v-model:checked="flyPrimaryStatus"
                  @change="handleChangeCheckChange('flyPrimaryStatus', !flyPrimaryStatus)">
                  <div class="check-content">
                    <svg-icon name="fly" :size="18" color="#297acf" className="color-primary"></svg-icon>
                    <div class="check-txt"> 低风险 </div>
                  </div>
                </a-checkbox>
              </div>
            </div>
          </template>
          <div class="m-s-icon td">
            <svg-icon name="fly" :size="16"></svg-icon>
          </div>
        </a-popover>

        <div class="m-s-zoom">
          <div class="zoom-add" @click.prevent.stop="zoomInViaNavigation">
            <PlusOutlined />
          </div>
          <div class="zoom-minus" @click.prevent.stop="zoomOutViaNavigation">
            <MinusOutlined />
          </div>
        </div>
        <a-popover overlayClassName="css-1dowtov" placement="leftBottom" trigger="hover">
          <div class="m-s-map-icon">
            <div class="select-btn">
              <img :src="mapIcon" />
            </div>
          </div>
          <template #title>{{ '' }}</template>
          <template #content>
            <div class="map-imglayer-data">
              <div class="m-i-d-title"> 地图实验室 </div>
              <div class="select-imglayer">

                <div class="img-w" :class="{ active: currentLayer === 0 }" @click.stop="handleSettingLayer(0,showImgLayer.includes('img_w_label'))">
                  <div class="img-w-mark">
                    <a-checkbox-group v-model:value="showImgLayer"
                       @change="(val)=>handleChangeImgLayer(val,0)">
                      <a-checkbox v-for="(dict,index) in layerOptions" :key="dict" :value="dict" v-show="index === 0"></a-checkbox>
                      </a-checkbox-group>
                    <span> 开启路网 </span>
                  </div>
                  <div class="img-w-name">
                    <span>天地图</span>
                  </div>
                </div>
                <div class="img-w" :class="{ active: currentLayer === 1 }" @click.stop="handleSettingLayer(1, showImgLayer.includes('a_map_img_w_label'))">
                  <div class="img-w-mark">
                    <a-checkbox-group v-model:value="showImgLayer" @change="(val)=>handleChangeImgLayer(val,1)">
                      <a-checkbox v-for="(dict,index) in layerOptions" :key="dict" :value="dict" v-show="index === 1"></a-checkbox>
                    </a-checkbox-group>
                    <span> 开启路网 </span>
                  </div>
                  <div class="img-w-name">
                    <span>高德地图</span>
                  </div>
                </div>
                <!-- <div class="img-w" :class="{ active: currentLayer === 2 }" @click.stop="handleSettingLayer(2, showImgLayer.includes('baidu_img_w_label'))">
                  <div class="img-w-mark">
                    <a-checkbox-group v-model:value="showImgLayer"
                       @change="(val)=>handleChangeImgLayer(val,2)">
                      <a-checkbox v-for="(dict,index) in layerOptions" :key="dict" :value="dict" v-show="index === 2"></a-checkbox>
                      </a-checkbox-group>
                    <span> 开启路网 </span>
                  </div>
                  <div class="img-w-name">
                    <span>百度地图</span>
                  </div>
                </div> -->
              </div>
            </div>
          </template>
        </a-popover>
      </div>
    </div>
    <div :class="{ current: showCurrentPoint, addCurrent: state.currentType === 'PointLine' }" id="cesium-map"
      ref="cesiumContainer" class="cesium-map"></div>
  </div>
</template>

<script setup lang="ts">
import flyContrainer from './cesium/fly_contrainer.vue'
import { onMounted, ref, onBeforeUnmount, computed, watch, nextTick, defineAsyncComponent, reactive } from 'vue'
import {
  initCesiumMap, getCesiumMap, getCesiumDataSource, showImgLayer, layerOptions, handleSettingLayer, state as states, MapTypeName, changeModel, state,
  load3DTilesUrl, pointCloudModelFn,
  handleShowFlySetting,
  currentLayer, sharePane
} from '/@/hooks/Cesium'
import QrcodeVue from 'qrcode.vue'
import pin from '/@/assets/icons/pin-2d8cf0.svg'
import { useMyStore } from '../store'
import * as Cesium from 'cesium'
import { getApp } from '../root'
import { EFlightAreaType } from '../types/flight-area'
import { MapDoodleEnum } from '../types/map-enum'
import { MapDoodleType, MapElementEnum } from '../constants/map'
import emitter from '../event-bus'
import { uuidv4 } from '../utils/uuid'
import moment from 'moment'
import { saveCustomFlightArea } from '../api/flight-area'
import { useRoute, useRouter } from 'vue-router'
import { HomeFilled, CloseOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import mapIcon from '/@/assets/images/map-icon.png'
import { ELocalStorageKey } from '../types'
import { currentIndex, closeCurrentMedia, currentMediaList, setCurrent, mediaSwitch } from '/@/hooks/Cesium/draw-image'
import { postElementsReq, updateElementsReq } from '../api/layer'
import dayjs from 'dayjs'
import { hideModelList, keepModelList, modelTreeData, showModelChange, showModelList, handleMouseLeave, getTotalModelCount, isModelTypeActive, getModelTypeDesc, expandedTreeNodes, selectModelType, toggleTreeNode, countFolderModels, countSubFolderModels, countWorkspaceModels, countModelTypes, loadModelList, clearModelType } from '../hooks/Cesium/model-draw'

const MediaView = defineAsyncComponent(() => import('/@/components/media/media-view.vue'))
const MarkInfo = defineAsyncComponent(() => import('/@/components/mark-info/index.vue'))
const FlySetting = defineAsyncComponent(() => import('/@/components/cesium/fly_setting.vue'))
const AirportModal = defineAsyncComponent(() => import('/@/components/cesium/airport.vue'))
const FlightAreaActionIcon = defineAsyncComponent(() => import('./flight-area/FlightAreaActionIcon.vue'))
const FlightAreaDrawModal = defineAsyncComponent(() => import('./flight-area/FlightAreaDrawModal.vue'))
const GActionType = defineAsyncComponent(() => import('/@/components/cesium/g-action-type.vue'))
const route = useRoute()
const router = useRouter()
const cesiumContainer = ref(null)
const viewer = ref<Cesium.Viewer | null>(null)
const mapDataSource = ref(null)
const drawings = ref([])
const store = useMyStore()
const mouseMode = ref(false)
const isFlightArea = ref(false)

const showDrawModal = ref(false)
const currentAreaData = ref<any>({})
const tempEntityId = ref<string>('')
const isFlightAreaRouter = computed(() => route.path.includes('flight-area'))
const isSettingPlanar = computed(() => route.name === 'waylineEditPlanar')
const isDataUi = computed(() => route.name === 'dataUi')
const isWaylineEdit = computed(() => route.name === 'waylineEdit' || route.name === 'waylineEditPlanar')
const username = localStorage.getItem(ELocalStorageKey.Username) || ''
const notieList = computed(() => store.state.notieList)
const getActive = computed(() => !store.state.headerVisible)
const shareId = computed(() => store.state.layerBaseInfo.share)
const isFlyArea = computed(() => store.state.isFlyArea)
const isCustumFlyArea = computed(() => store.state.isCustumFlyArea)
const flyErrorStatus = computed(() => store.state.flyErrorStatus)
const flyWarningStatus = computed(() => store.state.flyWarningStatus)
const flyPrimaryStatus = computed(() => store.state.flyPrimaryStatus)
const waylineInfo = computed(() => store.state.waylineInfo)
const workspaceList = computed(() => store.state.workspaceList || [])
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId) || ''
const is_waylineTemplate = computed(() => store.state.waylineTemplate)
const is_waylineDevice = computed(() => store.state.waylineDevice)
const FlightSimulationFlag = computed(() => store.state.FlightSimulationFlag)
const showPointCloud = computed({
  get: () => store.state.showPointCloud,
  set: (val) => {
    store.commit('SET_POINT_CLOUD', val)
    handleChangePointCloud(val)
  }
})
const showModelTileset = computed({
  get: () => store.state.showModelTileset,
  set: (val) => {
    store.commit('SET_MODEL_TILESET', val)
    handleChangeTitleset(val)
  }
})

export interface FlightAreaDrawData {
  id: string
  name: string
  type: 'circle' | 'polygon'
  coordinates: any[]
  radius?: number
  area: number
  color: string
  drawer?: string
}

const showEditRouter = computed(() => store.state.showEditRouter)

function handleChangeImgLayer (val:string[], number:number) {
  nextTick(() => {
    handleSettingLayer(number, val.includes(layerOptions[number]))
  })
}

function handleChangePointCloud (val: boolean) {
  nextTick(() => {
    clearModelType()
    pointCloudModelFn()
  })
}
function handleChangeTitleset (val: boolean) {
  nextTick(() => {
    clearModelType()
    pointCloudModelFn()
  })
}
function handleChangeCheckChange (key: string, flag: boolean) {
  if (key === 'flyErrorStatus') {
    store.commit('SET_FLY_ERROR_STATUS', flag)
  } else if (key === 'flyWarningStatus') {
    store.commit('SET_FLY_WARNING_STATUS', flag)
  } else if (key === 'flyPrimaryStatus') {
    store.commit('SET_FLY_PRIMARY_STATUS', flag)
  }
}
function handleSwitchChange (val) {
  store.commit('SET_FLY_AREA_FLAG', val)
  const list = store.state.custumFlyList
  list.forEach((item) => {
    item.show = val
  })
  store.commit('SET_CUSTUM_FLY_LIST', list)
  state.drawFlightArea?.setCircleList(list)
}
function handleSwitchCustumChange (val) {
  store.commit('SET_CUSTUM_FLY_AREA_FLAG', val)
  const list = store.state.crawlerList
  list.forEach((item) => {
    item.status = val
  })
  store.commit('SET_CRAWLER_LIST', list)
  state.drawFlightArea?.setApiListStatusChange(list, val)
  console.log(list, val, 'handleSwitchCustumChange')
}
function drawCesium (type: string) {
  const startPoint = state.drawRouteTool?.getStartingPoint()
  if (type === 'PointLine' && !startPoint) {
    message.error('请先选择起始点')
    return
  }
  if (isFlightArea.value) {
    state.drawFlightArea?.clearDrawEntity()
    state.rightClick = false
  }
  if (states.isDraw) {
    states.drawTool?.stopDrawing()
  }
  if (!states.currentType || states.currentType !== type) {
    states.currentType = type
    states.isDraw = true
    const json = localStorage.getItem('editWayline')
    if (type === 'PointLine') {
      if (json) {
        states.drawRouteTool?.drawDrawPointLine()
      } else {
        states.drawRouteTool?.activate()
      }
    } else if (type === 'Circle') {
      states.drawCircleTool?.startDraw()
    } else {
      states.drawTool?.activate(type)
    }
  } else {
    states.currentType = null
    states.isDraw = false
    states.drawRouteTool?.stopDrawing()
    states.drawTool?.stopDrawing()
    states.drawCircleTool?.endDraw()
  }
}
const showCurrentPoint = computed(() => store.state.startPointFlag)
function zoomInViaNavigation () {
  states.drawTool?.zoomInViaNavigation()
}
function zoomOutViaNavigation () {
  states.drawTool?.zoomOutViaNavigation()
}
function handleChangeModel () {
  changeModel(MapTypeName[states.mapType])
}
const FlightAreaType = {
  Point: MapElementEnum.PIN,
  Polyline: MapElementEnum.LINE,
  Polygon: MapElementEnum.POLY,
  Circle: 3,
}
function getDrawMarkCallback (obj: any) {
  if (states.currentType) {
    console.log(obj, 'obj')
    const saveData = {
      id: uuidv4(),
      name: `${state.currentType}-${shareId.value}-${moment().format('YYYY-MM-DD HH:mm')}`,
      resource: {
        type: FlightAreaType[state.currentType],
        content: {
          type: 'Feature',
          properties: {
            color: obj.color,
            clampToGround: false
          },
          geometry: {
            radius: obj.radius || 0,
            coordinates: obj.position,
            type: state.currentType === 'Polyline' ? 'LineString' : state.currentType,

          },
        },
        user_name: username
      }
    }
    postElementsReq(shareId.value, saveData).then((res) => {
      if (res.code === 0) {
        const list = store.state.markList
        const index = list.findIndex((el) => el.id === saveData.id)
        if (index >= 0) {
          list.splice(index, 1, saveData)
          store.commit('SET_MARK_LIST', list)
        } else {
          list.push(saveData)
          store.commit('SET_MARK_LIST', list)
        }
        state.drawTool?.addAPIResponseGraphic(saveData)
        nextTick(() => {
          const drawing = state.drawTool?.getDrawingById(saveData.id)
          if (drawing) {
            state.drawTool?.selectDrawing(drawing)
          }
        })
        store.commit('SET_MARK_CURRENT', { ...saveData, type: state.currentType })
      }
    })
  }
}

function getDrawCallback (obj: any) {
  if (isFlightArea.value) {
    // 计算面积和半径
    let area = 0
    let radius = 0
    let coordinates = []

    if (state.currentType === 'circle') {
      // 圆形区域
      radius = obj.radius || 0
      area = calculateCircleArea(radius)
      coordinates = obj.center || []
    } else {
      // 多边形区域
      coordinates = obj.coordinates || obj.latlngList || [] // 修正：使用 coordinates 而不是 latlngList
      area = calculatePolygonArea(coordinates)
    }

    // 保存临时实体ID，用于取消时删除
    tempEntityId.value = obj.entity?.id || ''
    const workspace_id = store.state.customWorkspace || workspaceId || workspaceList.value[0].workspace_id || ''

    // 设置当前区域数据
    currentAreaData.value = {
      id: uuidv4(),
      name: `${obj.color === '#19be6b' ? 'dfence' : 'nfz'}-${moment().format('YYYY-MM-DD HH:mm')}`,
      type: state.currentType,
      coordinates: coordinates,
      radius: radius,
      area: area,
      color: obj.color,
      drawer: username,
      workspace_id: workspace_id
    }

    // 显示弹层
    showDrawModal.value = true
    state.drawFlightArea.removeEntity(tempEntityId.value)
  }
}

// 计算圆形面积
function calculateCircleArea (radius: number): number {
  return Math.PI * radius * radius
}

// 计算多边形面积（使用Cesium的面积计算方法）
function calculatePolygonArea (coordinates: number[][]): number {
  if (!coordinates || coordinates.length === 0 || coordinates[0].length < 3) {
    return 0
  }

  try {
    const ring = coordinates[0]
    // 将经纬度坐标转换为笛卡尔坐标
    const cartesians = ring.map(coord => {
      return Cesium.Cartesian3.fromDegrees(coord[0], coord[1], coord[2] || 0)
    })

    const area = Cesium.Ellipsoid.WGS84.geodesicArea(cartesians)

    // 计算多边形面积
    // return Cesium.PolygonGeometry.computeArea(cartesians)
    return Math.abs(area)
  } catch (error) {
    if (coordinates[0] && coordinates[0].length > 2) {
      return calculateSimplePolygonArea(coordinates[0])
    }
    return 0
  }
}

function calculateSimplePolygonArea (ring: number[][]): number {
  let area = 0
  const R = 6371000 // 地球半径（米）
  const length = ring.length

  if (length < 3) return 0

  // 将经纬度转换为弧度
  const coords = ring.map(coord => {
    const lon = coord[0] * Math.PI / 180
    const lat = coord[1] * Math.PI / 180
    const h = coord[2] || 0
    return { lon, lat, h }
  })

  // 使用球面三角形面积公式（Girard's theorem）
  for (let i = 0; i < length; i++) {
    const j = (i + 1) % length

    area += (coords[j].lon - coords[i].lon) *
      (2 + Math.sin(coords[i].lat) + Math.sin(coords[j].lat))
  }

  area = Math.abs(area * R * R / 2)
  return area
}

// 处理弹层确认
function handleAreaConfirm (saveData: any) {
  const type = saveData.color !== '#19be6b' ? EFlightAreaType.NFZ : EFlightAreaType.DFENCE
  if (saveData.type !== 'circle') {
    saveData.coordinates[0].push(saveData.coordinates[0][0])
  }
  const saveGeo = {
    id: saveData.id,
    name: saveData.name,
    type: type,
    content: {
      properties: {
        color: saveData.color,
        clampToGround: false,
        drawer: username, // 添加绘制者信息
        area: saveData.area, // 添加面积信息
        radius: saveData.radius // 添加半径信息
      },
      geometry: {
        coordinates: saveData.coordinates,
        radius: saveData.radius,
        type: saveData.type === 'circle' ? 'Circle' : 'Polygon'
      },
      type: 'Feature'
    }
  }

  saveCustomFlightArea(saveGeo, saveData.areaWork).then((res) => {
    if (res.code !== 0) {
      message.error('保存失败')
      // 保存失败时删除实体
      state.drawFlightArea.removeEntity(tempEntityId.value)
    } else {
      message.success('保存成功')
      if (!route.path.includes('flight-area')) {
        if (saveData.type === 'circle') {
          state.drawFlightArea?.setCircleInfo(saveGeo.content, saveGeo)
        } else {
          state.drawFlightArea?.setPolygonInfo(saveGeo.content, saveGeo)
        }
      }
    }
  }).finally(() => {
    state.drawFlightArea.removeEntity(tempEntityId.value)
    // 清理临时实体
    tempEntityId.value = ''
    showDrawModal.value = false
    store.dispatch('getCustumFlyList', '')
    emitter.emit('updateFlightArea')
  })
}

// 处理弹层取消
function handleAreaCancel () {
  // 取消时删除临时绘制的实体
  if (tempEntityId.value) {
    state.drawFlightArea?.removeEntity(tempEntityId.value)
    tempEntityId.value = ''
  }
  showDrawModal.value = false
}

function draw (type: MapDoodleType, bool: boolean, flightAreaType?: EFlightAreaType) {
  state.currentType = type
  mouseMode.value = bool
  isFlightArea.value = !!flightAreaType
  state.drawFlightArea?.clearDrawEntity()
  if (type === 'circle') {
    if (isFlightArea.value) {
      state.drawFlightArea?.setDrawColor(flightAreaType === EFlightAreaType.DFENCE ? '#19be6b' : '#FF4949')
      state.drawFlightArea?.startDrawCircle()
    } else {
      state.drawFlightArea?.clearDrawEntity()
    }
  } else if (type === 'polygon') {
    if (isFlightArea.value) {
      state.rightClick = true
      state.drawFlightArea?.setDrawColor(flightAreaType === EFlightAreaType.DFENCE ? '#19be6b' : '#FF4949')
      state.drawFlightArea?.startDrawPolygon()
    } else {
      state.drawFlightArea?.clearDrawEntity()
    }
  } else if (type === 'off') {
    state.drawFlightArea?.clearDrawEntity()
    state.rightClick = false
  }
}

/**
* 选择航班区域的操作函数
*
* @param options 包含类型与是否为圆形的对象
* @param options.type 航班区域类型
* @param options.isCircle 是否为圆形
*/
function selectFlightAreaAction ({ type, isCircle }: { type: EFlightAreaType, isCircle: boolean }) {
  draw(isCircle ? MapDoodleEnum.CIRCLE : MapDoodleEnum.POLYGON, true, type)
}
function handleToPath () {
  router.push({ path: '/notieDetail' })
}

// 添加建筑相关的状态
const showBuildingControls = ref(false)
const selectedBuildingLayer = ref('')
const customTilesetUrl = ref('')
const currentBuildingTileset = ref<any>(null)
const buildingsVisible = ref(false)
const loadProgress = ref(0)
const memoryUsage = ref(0)
const buildingError = ref('')

// 处理建筑图层切换
const handleBuildingLayerChange = async (value: string) => {
  buildingError.value = ''
  if (value === 'osm') {
    await loadOSMBuildingLayer()
  } else if (value === 'test') {
    await loadTestBuilding()
  }
}

// 加载OSM建筑（带错误处理）
const loadOSMBuildingLayer = async () => {
  try {
    // 先移除现有的建筑
    if (currentBuildingTileset.value) {
      currentBuildingTileset.value.destroy()
      currentBuildingTileset.value = null
    }

    // 尝试不同的数据源
    let result = null

    try {
      // 首先尝试ArcGIS的免费数据源
      result = await load3DTilesUrl('https://tiles.arcgis.com/tiles/P3ePLMYs2RVChkJx/arcgis/rest/services/Buildings_NewYork/SceneServer/layers/0', {
        position: { lng: 113.453275, lat: 23.185216 }, // 使用广州坐标
        scale: 0.8,
        maximumScreenSpaceError: 12
      })
    } catch (arcgisError) {
      console.warn('ArcGIS数据源加载失败，尝试本地数据:', arcgisError)

      // 如果ArcGIS失败，尝试加载本地测试数据
      result = await loadTestBuilding()
    }

    if (result) {
      currentBuildingTileset.value = result
      buildingsVisible.value = true

      // 如果是3D Tiles，添加加载进度监听
      if (result.tileset) {
        result.tileset.tileLoad.addEventListener((tile: any) => {
          if (result.tileset) {
            const tilesLoaded = result.tileset.tilesLoaded.length
            const totalTiles = result.tileset.tilesLoaded.length + result.tileset.tilesProcessing.length
            loadProgress.value = Math.round((tilesLoaded / totalTiles) * 100)

            // 更新内存使用
            memoryUsage.value = Math.round(result.tileset.totalMemoryUsageInBytes / (1024 * 1024))
          }
        })
      }

      message.success('建筑模型加载成功')
    }
  } catch (error: any) {
    console.error('加载建筑失败:', error)
    buildingError.value = error.message || '加载建筑模型失败'
    message.error(buildingError.value)

    // 提供一个备选方案
    if (error.message.includes('网络请求失败') || error.message.includes('CORS')) {
      buildingError.value += '。建议：1) 检查网络连接 2) 使用本地数据源 3) 配置代理服务器'
    }
  }
}

// 加载测试建筑（备选方案）
const loadTestBuilding = async () => {
  try {
    if (currentBuildingTileset.value) {
      currentBuildingTileset.value.destroy()
      currentBuildingTileset.value = null
    }

    const result = await loadTestBuilding()
    // if (result) {
    //   const initialPosition = Cesium.Cartesian3.fromDegrees(
    //     -74.01881302800248,
    //     40.69114333714821,
    //     753,
    //   )
    //   const initialOrientation = Cesium.HeadingPitchRoll.fromDegrees(
    //     21.27879878293835,
    //     -21.34390550872461,
    //     0.0716951918898415,
    //   )
    //   viewer.value.scene.camera.setView({
    //     destination: initialPosition,
    //     orientation: initialOrientation,
    //     endTransform: Cesium.Matrix4.IDENTITY,
    //   })
    //   currentBuildingTileset.value = result
    //   buildingsVisible.value = true
    //   loadProgress.value = 100
    //   memoryUsage.value = 0
    //   message.info('测试建筑加载成功（这是一个示例）')
    // }
    if (result) {
      currentBuildingTileset.value = result
      buildingsVisible.value = true
      loadProgress.value = 100
      memoryUsage.value = 0
      message.info('测试建筑加载成功（这是一个示例）')
    }
  } catch (error: any) {
    buildingError.value = error.message || '加载测试建筑失败'
    message.error(buildingError.value)
  }
}

// 加载自定义建筑
const loadCustomBuildings = async () => {
  if (!customTilesetUrl.value.trim()) {
    message.warning('请输入3D Tiles URL')
    return
  }

  try {
    if (currentBuildingTileset.value) {
      currentBuildingTileset.value.destroy()
    }
    buildingError.value = ''
    const result = await load3DTilesUrl(customTilesetUrl.value.trim(), {
      skipTransform: true
      // position: { lng: states.position.longitude, lat: states.position.latitude },
      // scale: 1.0
    })

    if (result) {
      currentBuildingTileset.value = result
      buildingsVisible.value = true
      message.success('自定义建筑模型加载成功')
    }
  } catch (error: any) {
    console.error('加载自定义建筑失败:', error)
    buildingError.value = error.message || '加载自定义建筑模型失败'
    message.error(buildingError.value)
  }
}

// 切换建筑显示/隐藏
const toggleBuildings = () => {
  if (currentBuildingTileset.value) {
    buildingsVisible.value = !buildingsVisible.value
    if (currentBuildingTileset.value.tileset) {
      currentBuildingTileset.value.tileset.show = buildingsVisible.value
    } else if (currentBuildingTileset.value.entity) {
      currentBuildingTileset.value.entity.show = buildingsVisible.value
    }
  }
}

// 移除建筑
const removeBuildings = () => {
  if (currentBuildingTileset.value) {
    currentBuildingTileset.value.destroy()
    currentBuildingTileset.value = null
    buildingsVisible.value = false
    loadProgress.value = 0
    memoryUsage.value = 0
    buildingError.value = ''
    message.info('建筑模型已移除')
  }
}
const getDrawGraphicUpdatedCallback = (graphic) => {
  const { positions } = graphic
  const latlng = positions.map(item => [item.longitude, item.latitude, 0])
  if (graphic.resource.content.geometry.type === 'Circle') {
    graphic.resource.content.geometry.coordinates = latlng[0]
  } else {
    graphic.resource.content.geometry.coordinates = latlng
  }
  const pointSave = { ...graphic }
  pointSave.content = graphic.resource.content
  delete pointSave.resource
  state.drawTool.restoreCameraSettings()
  updateElementsReq(graphic.id, pointSave)
  nextTick(() => {
    state.drawTool?.selectDrawingById(graphic.id)
    if (graphic.resource.content.geometry.type === 'Circle') {
      store.commit('SET_CURRENT_CIRCLE', { ...graphic })
    } else if (graphic.resource.content.geometry.type === 'Polygon') {
      store.commit('SET_CURRENT_POLYGON', { ...graphic })
    } else if (graphic.resource.content.geometry.type === 'Polyline') {
      store.commit('SET_CURRENT_POLYLINE', { ...graphic })
    } else if (graphic.resource.content.geometry.type === 'Point') {
      store.commit('SET_CURRENT_POINT', { ...graphic })
    }
  })
}

onMounted(async () => {
  const app = getApp()
  store.commit('SET_EDIT_ROUTER', false)
  emitter.on('flightAreasDroneLocation', getDrawCallback)
  emitter.on('elementMarkInfo', getDrawMarkCallback)
  emitter.on('graphicUpdated', getDrawGraphicUpdatedCallback)
  await Promise.all([initCesiumMap(cesiumContainer.value, app)])
  viewer.value = getCesiumMap()
  mapDataSource.value = getCesiumDataSource()
  drawings.value = states.drawTool.getDrawings()
  if (store.state.markList && store.state.markList.length > 0) {
    await states.drawTool?.addAPIResponseGraphics(store.state.markList)
  }
  if (store.state.custumFlyList && store.state.custumFlyList.length > 0 && isFlyArea.value) {
    await states.drawFlightArea?.setCircleList(store.state.custumFlyList)
  }
  loadModelList(true)
})

onBeforeUnmount(() => {
  emitter.off('flightAreasDroneLocation')
  emitter.off('elementMarkInfo')
  emitter.off('graphicUpdated')
  if (states.drawTool) {
    states.drawTool.destroy()
  }
  if (state.drawFlightArea) {
    state.drawFlightArea.clearEntity()
  }
  if (state.drawRouteTool) {
    state.drawRouteTool.destroy()
  }
  if (viewer.value) {
    viewer.value.destroy()
    viewer.value = null
  }
  if (tempEntityId.value) {
    state.drawFlightArea?.removeEntity(tempEntityId.value)
  }
  if (currentBuildingTileset.value) {
    currentBuildingTileset.value.destroy()
  }
})
</script>

<style scoped lang="scss">
.route-core-info {
  padding: 24px;
  position: fixed;
  bottom: 52px;
  left: 656px;
  z-index: 1001;
  width: 1168px;
  height: 154px;
  background: var(--colorBgElevated);
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--colorText);
  transition: all .4s;

  &.is-template {
    left: 880px;
    width: 1025px;
  }

  &.is-device {
    left: 880px;
    width: 1080px;
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    .route-name {
      width: 300px;
      height: 28px;
      line-height: 28px;
      font-weight: 500;
      font-size: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .create-info {
      display: flex;
      align-items: center;
      font-size: 14px;

      .anticon {
        font-size: 17px;
      }

      .creator {
        margin: 0 8px;
      }

      .phone {
        margin-right: 17px;
      }

      .create-time {
        margin-left: 8px;
        margin-right: 17px;
      }
    }
  }

  .bottom {
    display: flex;
    align-items: center;
    -webkit-user-select: none;
    user-select: none;

    .area-item {
      width: 150px !important;
    }

    .wayline-info-item {
      margin-right: 24px;
      width: 120px;

      .title {
        margin-bottom: 8px;
        width: 100%;
        height: 22px;
        line-height: 22px;
        font-weight: 400;
        font-size: 14px;
        color: var(--colorTextSecondary);
      }

      .text {
        max-width: 120px;
        height: 24px;
        line-height: 24px;
        font-weight: 500;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .update-time {
        position: relative;
        bottom: 1px;
        left: 8px;
        font-weight: 400;
        font-size: 14px;
      }
    }

  }

  .wayline-propety,
  .end-update-time {
    width: 200px !important;
  }
}

.uva-level {
  width: 152px;
  height: 116px;

  .v-l-tip {
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    font-size: 16px;

    .tip-txt {
      font-weight: bold;

      i {
        cursor: pointer;
      }
    }
  }

  .v-l-check {
    margin: 6px 0 0;

    .check-content {
      display: flex;
      align-items: center;
      margin-left: 4px;

      .svg-icon {
        border-radius: 50%;
        border: 1px solid;

        &.color-error {
          border-color: #dc4446;
        }

        &.color-warning {
          border-color: #d89614;
        }

        &.color-primary {
          border-color: #297acf;
        }
      }

      .check-txt {
        line-height: 20px;
        margin: 0 0 0 4px;
        color: #fff;
      }
    }
  }
}

.flight-area {
  width: 180px;
  height: 325px;

  .ant-divider {
    background-color: rgba(253, 253, 253, 0.12);
  }

  .f-a-switch {
    display: flex;
    font-size: 16px;

    .txt {
      line-height: 22px;
      margin: 0 0 0 4px;
    }
  }

  .f-a-txt {
    margin: 0 0 6px;
    text-align: center;
    display: flex;
    align-items: center;
    padding: 0 0 0 34px;

    .color1 {
      border-color: red;
      border-style: dotted;
      background-color: #ff000080
    }

    .color2 {
      border-color: #0f0;
      border-style: dotted;
      background-color: rgba(0, 255, 0, 0.5);

    }

    .txt {
      line-height: 20px;
      margin: 0 0 0 4px;
    }
  }

  .f-a-tips {
    margin: 0 0 0 20px;
  }

  .f-a-check {
    margin: 0 0 0 10px;

    .check-content {
      display: flex;

      .color3 {
        border-color: #e2573f;
        background-color: #e2573f80;
      }

      .color4 {
        border-color: #989898;
        background-color: #98989880
      }

      .color5 {
        border-color: #1389f2;
        background-color: #1389f280
      }

      .color6 {
        border-color: #ffcc03;
        background-color: #ffcc0380
      }

      .color7 {
        border-color: #ee8918;
        background-color: #ee891880
      }

      .color8 {
        border-color: #39c4db;
        background-color: #39c4db80
      }

      .color9 {
        border-color: #1dc61d;
        background-color: #1dc61d80
      }

      .check-txt {
        line-height: 20px;
        margin: 0 0 0 4px;
        color: #fff;
      }
    }
  }

  .round {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 3px dotted red;
    border-radius: 50%;
    line-height: 24px;

  }
}

.cesium-container {
  height: 100%;
  width: 100%;
  position: absolute;
  overflow: hidden;

  &.data-ui {
    :deep(.compass) {
      right: 25%;
    }
  }

  .notie-list {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 99%;
    z-index: 301;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding: 12px;
    background: #fff4e6;
    border-radius: 4px;

    &.is-template {
      left: 445px;
      width: 74%;
    }

    &.is-device {
      left: 275px;
      width: 83.5%
    }

    &.is-waline-edit {
      top: 63px;
    }

    &.active {
      top: 3px;
      left: 5px;
    }

    .notie-title-type {
      -webkit-box-flex: 0;
      flex: none;
      line-height: 16px;
      padding: 0 8px;
      font-size: 12px;
      border: 1px solid #be4e04;
      color: #be4e04;
      border-radius: 4px;
    }

    .notie-title-value {
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      margin-left: 8px;
      font-size: 14px;
      color: rgba(0, 0, 0, .65);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .detail-btn {
      -webkit-box-flex: 0;
      -ms-flex: none;
      flex: none;
      cursor: pointer;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      color: #0070d5;
      font-size: 14px;

      .arrow-right {
        width: 6px;
        height: 6px;
        margin-left: 4px;
        background-color: transparent;
        border-color: #0070d5;
        border-style: solid;
        border-width: 1px 1px 0 0;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }
  }

  .cesium-map {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 300;
  }

  :deep(.current) {
    .cesium-widget {
      canvas {
        cursor: url('/src/assets/icons/startPoint.png') 20 20, pointer;
      }
    }
  }

  :deep(.addCurrent) {
    .cesium-widget {
      canvas {
        cursor: url('/src/assets/icons/route-edit-add.svg') 20 20, pointer;
      }
    }
  }

  // 操作按钮面板
  .cesium-action-pane {
    position: absolute;
    top: 50px;
    right: 16px;
    z-index: 400;

    &.edit {
      top: 76px;
    }

    .g-action-item {
      width: 28px;
      height: 28px;
      background-color: black;
      color: $primary;
      border-radius: 2px;
      line-height: 28px;
      text-align: center;
      margin-bottom: 2px;
      border: 2px solid;
      border-color: black;
      border-radius: 2px 2px 0 0;
      position: relative;
      cursor: pointer;

      &:hover {
        border-color: $primary;
      }
    }

    .selection {
      border-color: $primary;

      &:before {
        content: "";
        position: absolute;
        right: -2px;
        top: -2px;
        border-width: 7px;
        border-style: solid;
        border-color: #00afff #00afff transparent transparent;
      }
    }
  }

}

.map-sidebar-com {
  .model-list-btn {
    // position: absolute;
    // right: 15px;
    // top: 250px;
    z-index: 1000;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    background: #1f1f1f; // 改为与右侧图标相同的深灰色
    backdrop-filter: blur(12px) saturate(180%);
    padding: 8px;
    border-radius: 3px;
    border: 1px solid rgba(255, 255, 255, 0.1); // 边框微调为半透明白色，更自然
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
    transition: all 0.3s ease;
    color: rgba(255, 255, 255, 0.8);

    &:hover {
      background: rgba(31, 31, 31, 0.05); // 悬停时略微提亮背景
      color: #1890ff; // 文字变为主蓝色
      border-color: #1890ff; // 边框也变为主蓝色
    }

    .anticon {
      font-size: 14px;
    }

    .btn-text {
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;
    }

    // 树形结构悬停列表样式
    .tree-model-list-popover {
      position: absolute;
      top: 0;
      right: 30px;
      width: 350px;
      max-height: 500px;
      background: #1f1f1f; // 深灰色背景
      backdrop-filter: blur(12px) saturate(180%);
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
      overflow: hidden;
      z-index: 1001;

      .tree-list-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        background: rgba(0, 0, 0, 0.3); // 更深的头部背景
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        .tree-list-title {
          color: rgba(255, 255, 255, 0.9);
          font-size: 14px;
          font-weight: 600;
        }

        .model-count {
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
          background: rgba(255, 255, 255, 0.1);
          padding: 2px 8px;
          border-radius: 10px;
        }
      }

      .tree-list-content {
        max-height: 450px;
        overflow-y: auto;
        padding: 8px;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
          background: rgba(24, 144, 255, 0.5); // 主蓝色滚动条
          border-radius: 3px;

          &:hover {
            background: rgba(24, 144, 255, 0.7);
          }
        }

        .tree-workspace,
        .tree-folder,
        .tree-subfolder,
        .tree-model {
          margin-bottom: 4px;

          .tree-workspace-header,
          .tree-folder-header,
          .tree-subfolder-header,
          .tree-model-header {
            cursor: pointer;
            padding: 8px 12px;
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 6px;
            transition: all 0.2s ease;

            &:hover {
              background: rgba(24, 144, 255, 0.1);
              border-color: rgba(24, 144, 255, 0.3);
            }

            .tree-node-title {
              display: flex;
              align-items: center;
              gap: 8px;
              color: rgba(255, 255, 255, 0.8);
              font-size: 13px;

              .tree-caret-icon {
                font-size: 12px;
                color: rgba(24, 144, 255, 0.8);
                flex-shrink: 0;
              }

              .tree-node-name {
                flex: 1;
                font-weight: 600;
              }

              .tree-node-count {
                color: rgba(255, 255, 255, 0.5);
                font-size: 12px;
                background: rgba(255, 255, 255, 0.1);
                padding: 2px 8px;
                border-radius: 10px;
              }
            }
          }

          .tree-children,
          .tree-subfolders,
          .tree-models {
            margin-top: 6px;
            padding-left: 20px;
          }

          .tree-model-types {
            margin-top: 4px;
            padding-left: 20px;

            .tree-model-type {
              cursor: pointer;
              margin-bottom: 4px;
              padding: 8px 12px;
              background: rgba(255, 255, 255, 0.05);
              border: 1px solid rgba(255, 255, 255, 0.1);
              border-radius: 6px;
              transition: all 0.2s ease;

              &:hover {
                background: rgba(24, 144, 255, 0.1);
                border-color: rgba(24, 144, 255, 0.3);
                transform: translateX(2px);
              }

              &.active {
                background: rgba(24, 144, 255, 0.15);
                border-color: rgba(24, 144, 255, 0.5);
                box-shadow: 0 0 12px rgba(24, 144, 255, 0.3);

                .model-type-check {
                  color: #1890ff;
                }
              }

              .model-type-content {
                display: flex;
                align-items: center;
                gap: 10px;

                .model-type-icon {
                  flex-shrink: 0;
                  width: 24px;
                  height: 24px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background: rgba(24, 144, 255, 0.15);
                  border-radius: 4px;
                  color: rgba(24, 144, 255, 0.9);
                  font-size: 12px;
                }

                .model-type-info {
                  flex: 1;
                  min-width: 0;

                  .model-type-name {
                    display: block;
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 13px;
                    font-weight: 500;
                    margin-bottom: 2px;
                  }

                  .model-type-desc {
                    display: block;
                    color: rgba(255, 255, 255, 0.5);
                    font-size: 11px;
                    background: rgba(255, 255, 255, 0.05);
                    padding: 1px 6px;
                    border-radius: 3px;
                    display: inline-block;
                  }
                }

                .model-type-check {
                  flex-shrink: 0;
                  font-size: 12px;
                  color: rgba(255, 255, 255, 0.3);
                }
              }
            }
          }
        }
      }
    }
  }
  .ply-icon{
    position: absolute;
    right: 15px;
    top: 27%;
    z-index: 400;
    width: 28px;
      height: 28px;
      margin: 10px auto;
      border-radius: 2px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      background-color: #1f1f1f;
      color: rgba(255, 255, 255, 0.85);
      &:hover {
        color: #1088f2;
      }
  }
  .m-s-right-btn {
    position: absolute;
    right: 20px;
    bottom: 50px;
    z-index: 400;

    &.data-ui {
      right: 25.5%;
    }

    .td {
      font-weight: 700;
      color: #fff;
    }

    .m-s-icon {
      width: 28px;
      height: 28px;
      margin: 10px auto;
      border-radius: 2px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      position: relative;
      background-color: #1f1f1f;
      color: rgba(255, 255, 255, 0.85);

      &:hover {
        color: #1088f2;
      }
    }

    .m-s-zoom {
      width: 28px;
      margin: 10px auto;
      text-align: center;
      line-height: 28px;
      box-shadow: 0 0 4px #0009;
      cursor: pointer;

      .zoom-add {
        width: 28px;
        height: 28px;
        border-radius: 2px 2px 0 0;
        background-color: #1f1f1f;
        color: rgba(255, 255, 255, 0.85);

        &:hover {
          color: #1088f2;
        }
      }

      .zoom-minus {
        width: 28px;
        height: 28px;
        border-radius: 0 0 2px 2px;
        background-color: #1f1f1f;
        color: rgba(255, 255, 255, 0.85);

        &:hover {
          color: #1088f2;
        }
      }
    }

    .m-s-map-icon {
      width: 40px;
      height: 40px;
      background: #fff;
      border-radius: 50%;
      margin: 10px auto;
      padding: 3px 0 0;
      cursor: pointer;

      .select-btn {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        margin: 0 auto;
        -webkit-user-select: none;
        user-select: none;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%
        }
      }
    }
  }
}

.map-imglayer-data {
  width: 240px;
  height: 100px;
  position: relative;

  .m-i-d-title {
    font-weight: 600;
    margin: 0 0 6px;
    font-size: 14px;
  }

  .m-i-d-switch {
    display: flex;
    font-size: 14px;
    margin: 0 0 6px;

    .txt {
      line-height: 22px;
      margin: 0 0 0 4px;
    }
  }

  .switch-right {
    margin-left: 50px;
  }

  .select-imglayer {
    width: 100%;
    height: 100px;
    display: flex;
    // justify-content: space-around;

    .vec-w,
    .img-w {
      width: 120px;
      height: 80px;
      background-size: 100% 100%;
      position: relative;
      border: 2px solid #fff;

      &.active,
      &:hover {
        border: 2px solid #2d8cf0;

        .vec-w-name span,
        .img-w-name span {
          background-color: #2d8cf0;
        }
      }
    }

    .vec-w {
      background-image: url('/@/assets/images/map-icon2.png');
    }

    .img-w {
      background-image: url('/@/assets/images/map-icon.png');

      .img-w-mark {
        height: 24px;
        padding: 0 4px;
        background: #00000080;
        display: flex;
        color: #fff;

        .ant-checkbox-group {
          width: 30px;
        }

        .ant-checkbox-wrapper {
          color: #fff;
        }

        .txt {
          line-height: 22px;
          margin: 0 0 0 4px;
        }
      }
    }

    .vec-w-name,
    .img-w-name {
      position: absolute;
      right: 0;
      bottom: 0;
      line-height: 22px;
      color: #fff;
      width: 100%;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.5), transparent 0, rgba(0, 0, 0, 0.4));
      text-align: right;

      span {
        padding: 0 4px;
      }
    }
  }
}

.building-control-panel {
  position: absolute;
  top: 100px;
  right: 50px;
  width: 320px;
  background: rgba(255, 255, 255, 0.98);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 80vh;
  overflow-y: auto;

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #e8e8e8;
    background: #fafafa;
    border-radius: 8px 8px 0 0;

    h4 {
      margin: 0;
      font-size: 16px;
      color: #1890ff;
    }

    .anticon-close {
      cursor: pointer;
      color: #999;
      font-size: 14px;

      &:hover {
        color: #ff4d4f;
      }
    }
  }

  .panel-content {
    padding: 16px;

    .error-message {
      margin-bottom: 12px;
    }

    .data-source-info {
      margin-bottom: 12px;
    }

    .custom-input {
      margin-bottom: 16px;
    }

    .building-controls {
      display: flex;
      margin: 16px 0;
      padding: 12px 0;
      border-top: 1px solid #f0f0f0;
      border-bottom: 1px solid #f0f0f0;
    }

    .performance-stats {
      margin: 12px 0;

      .stat-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        font-size: 12px;
        color: #666;

        span:first-child {
          color: #333;
          font-weight: 500;
        }
      }
    }

    .usage-tips {
      margin-top: 12px;
      font-size: 12px;
      color: #888;
    }
  }
}
.share-point-panel{
  position: absolute;
    left: 500px;
    top: 300px;
    padding: 8px;
    background-color: #1f1f1f;
    z-index: 999;
    border-radius: 4px;
    .share-btn{
      padding: 0 10px 10px;
    position: relative;
    line-height: 30px;
    color: #fff;
    }
    .share-image-box{
      padding: 5px;
    }
}
</style>
